import script from "./Page_4.vue?vue&type=script&setup=true&lang=js"
export * from "./Page_4.vue?vue&type=script&setup=true&lang=js"

import "./Page_4.vue?vue&type=style&index=0&id=26124eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26124eca"]])

export default __exports__